export const progress = 'progress';
export const progressBar = 'progress-bar';
export const label_progress = 'Progress';
export const label_progressBar = 'Progress Bar';
export const category = 'Advanced';
export const progressValue = 'progress-value';
export const progressTotal = 'progress-total';
